import React from "react"
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import CustomCard from "../cards/CustomCard"
import {useMediaQuery} from 'react-responsive'

export default function PageAbout(props) {

    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })

    return (<>
        <Stack 
            direction="column"
            alignItems="center"
            spacing={1}
            sx={{ 
                pb: 5,
                marginX: isTabletOrMobile ? 0.5 : 10
            }}
        >
            <Typography variant="h3" sx={{ mt: 2, mb: 3 }}>
                Acerca de mi
            </Typography>

            <Stack 
                direction="column"
                alignItems="stretch"
                spacing={3}
            >
                <CustomCard
                    title="Estudios"
                    content="Soy Ingeniero en Automatización y Robótica de profesión.
                        A lo largo de mi carrera he aprendido varios lenguajes de programación, esto me ha ayudado a adquirir habilidades en distintos campos.
                        Entre los lenguajes que conozco están: C++, C#, Visual Basic 6, VB.NET, Python, Javascript, MySQL, MSSQL, PostgreSQL, MongoDB
                        He utilizado frameworks y herramientas como: React.js, Node.js, Express.js, B4a, B4i, GitHub.
                        Tengo conocimientos de electronica y programación de microcontroladores, principalmente arduino.
                        He creado e impreso, modelos 3D para ser utilizadas en componentes electronicos."
                />
                <CustomCard
                    title="Trabajos"
                    content="Trabajé durante 7 años en la empresa de desarrollo de software Sopytec. 
                        Me encargaba de desarrollar, programar e implementar todos los sistemas electronicos utilizados en equipos para control de acceso.
                        Estaba a cargo del desarrollo de un sistema de asistencia desarrollado en .NET (App de escritorio), 
                        asi como del soporte y atención al los clientes que utilizaban el programa.
                        Eventualemente comence la migración del sistema de asistencia a la web. Trabajé durante 1 año en la empresa Bartech.
                        Aqui continue la migración del sistema de asistencia web.
                        Tambien estaba a cargo del desarrollo e investigación para nuevos productos."
                />
                <CustomCard
                    title="Hobbies"
                    content="Estos últimos años mi mayor hobby a sido el desarrollo de video juegos.
                        En estos momentos me encuentro creando un juego con Unreal Engine 5."
                />
            </Stack>    
        </Stack>
    </>)
}